module.exports = __webpack_public_path__ + "img/logo-black.a332b7a3.png";